// Footer.js
import React from "react";
import "./Main/footer.css";
import playstore from "./../../images/transparent-apple.png";
import appstore from "./../../images/transparent-android.png";
import DKLOGO from "./../../images/logo-dk.png";
const Footer = () => {
  return (
    <footer className="footer text-center">
      <div className="row pt-3 d-flex justify-content-center">
        <div className="col-md-4 footer-logo d-flex flex-column align-items-start">
          <div>
            <img src={DKLOGO} />
          </div>
          <div className="footer-heading mt-3">
            <h1 className="mt-4">Get In Touch</h1>
            <p className="text-left" style={{ color: "#fff" }}>
              DIGITAL KIDU <span> - </span>
              <a
                href="https://www.digitalkidu.bt"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.digitalkidu.bt
              </a>
            </p>
          </div>
        </div>
        <div className="col-md-4 footer-logo d-flex flex-column align-items-start">
          <div className="footer-heading mt-3">
            <h4>Address</h4>
            <div>
              <div className="address">
                <div className="d-flex gap-3 align-items-center">
                  <i className="fa fa-envelope icon-footer"></i>
                  <a
                    href="mailto:help@dk.bt"
                    className="text-decoration-none text-dark"
                  >
                    <span> help@dk.bt</span>
                  </a>
                </div>

                <div className="d-flex gap-3 align-items-center mt-3">
                  <a
                    href="https://www.google.com/maps/place/Digital+Kidu+(DK)+Bank/@27.4791021,89.6349161,20.61z/data=!4m9!1m2!2m1!1sFJHP+J27,+Chubachu,+Thimphu!3m5!1s0x39e1956dfd3c1b17:0x502fb3a7b3e68201!8m2!3d27.4790433!4d89.6350397!16s%2Fg%2F11s8js055m?entry=ttu&g_ep=EgoyMDI0MTExOC4wIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-dark d-flex gap-3 align-items-center"
                  >
                    <i className="fa fa-location-dot icon-footer"></i>
                    <span> Chubachu, Thimphu | Bhutan</span>
                  </a>
                </div>
                <div className="d-flex gap-3 align-items-center mt-3">
                  <a
                    href="https://www.google.com/maps/place/Digital+Kidu+(DK)+Bank/@27.4791021,89.6349161,20.61z/data=!4m9!1m2!2m1!1sFJHP+J27,+Chubachu,+Thimphu!3m5!1s0x39e1956dfd3c1b17:0x502fb3a7b3e68201!8m2!3d27.4790433!4d89.6350397!16s%2Fg%2F11s8js055m?entry=ttu&g_ep=EgoyMDI0MTExOC4wIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-dark d-flex gap-3 align-items-center"
                  >
                    <i className="fa fa-phone icon-footer"></i>
                    <span> +975 17351921</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 footer-logo d-flex flex-column align-items-start">
          <div className="footer-heading mt-3">
            <h4>Download Now</h4>
            <div className="border rounded p-3">
              <h6 className="">Ngyelso App</h6>
              <div className="address d-flex gap-3 align-items-center justify-content-center">
                <a
                  href="https://play.google.com/store/apps/details?id=bt.digitalkidu.LeaveManagement"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={playstore}
                    alt="Play Store"
                    className="high-contrast-img"
                  />
                </a>
                <a
                  href="https://apps.apple.com/bt/app/ngyelso/id6479706168"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={appstore}
                    alt="App Store"
                    className="high-contrast-img"
                  />
                </a>
              </div>
            </div>
            <div className="border rounded p-3 mt-2">
              <h6 className="">DK Bank App</h6>
              <div className="address d-flex gap-3 align-items-center justify-content-center">
                <a
                  href="https://play.google.com/store/apps/details?id=bt.digitalkidu.DigitalKiduApp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={playstore}
                    alt="Play Store"
                    className="high-contrast-img"
                  />
                </a>
                <a
                  href="https://apps.apple.com/bt/app/dk-bank/id6462849899"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={appstore}
                    alt="App Store"
                    className="high-contrast-img"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <hr className="mt-4 footer-line" />
        <p className="text-white">DK Limited Copyright 2024</p>
      </div>
    </footer>
  );
};

export default Footer;
